/* eslint-disable react/jsx-filename-extension */
import React from "react"
import { graphql } from "gatsby"
import Layout from "../../templates/pageLayout"
import ServiceBtn from "../../components/serviceBtn"
import * as servicesCategoryStyles from "../../components/servicesCategory.module.css"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

export default function Aviation({ pageContext, data }) {
  const {
    breadcrumb: { crumbs },
  } = pageContext

  return (
    <Layout title="Aviation Services">
      <div className="container">
        <div className={servicesCategoryStyles.servicesContainer}>
          <Breadcrumb crumbs={crumbs} crumbSeparator=" > " />
          <h2>
            <span className={servicesCategoryStyles.serviceCategory}>
              AVIATION
            </span>{" "}
            SERVICES
          </h2>
          <p>
            We offer a great range of services for your aviation needs.{" "}
            <span style={{ color: "#FF6633" }}>
              Please select a category below.
            </span>
          </p>
          <ServicesContent data={data} />
        </div>
      </div>
    </Layout>
  )
}

class ServicesContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedSubCategory: "View All",
      services: [],
    }
  }

  componentDidMount() {
    const { data } = this.props
    const subCategories = [
      "View All",
      "Care",
      "Protection",
      "Customisation",
      "Classic Cars",
    ]
    const subCategoriesList = document.querySelector("#subCategoryFilter")

    const underline = document.createElement("div")
    underline.classList.add("filterItem__activeUnderline")

    {
      for (let i = 0; i < subCategories.length; i++) {
        const div = document.createElement("div")
        subCategoriesList.appendChild(div)

        div.classList.add("filterItem")
        div.innerHTML = subCategories[i]
        div.setAttribute("id", subCategories[i])

        if (subCategories[i] === this.state.selectedSubCategory) {
          div.classList.add("filterItem__active")
          div.appendChild(underline)
        }

        div.addEventListener("click", () => {
          this.setState({
            selectedSubCategory: subCategories[i],
          })
        })
      }
    }

    this.setState({ services: [] })

    data.allMdx.edges.map(({ node }) => {
      this.setState(state => {
        const services = state.services.push(
          <div key={node.frontmatter.title}>
            <ServiceBtn
              link={node.fields.slug}
              title={node.frontmatter.title}
              img={node.frontmatter.img.childImageSharp.fluid}
              id={node.frontmatter.title}
            />
          </div>
        )
      })
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let selectedSubCategory = this.state.selectedSubCategory
    const { data } = this.props

    const underline = document.createElement("div")
    underline.classList.add("filterItem__activeUnderline")

    if (selectedSubCategory) {
      if (selectedSubCategory != prevState.selectedSubCategory) {
        this.setState({
          services: [],
        })

        let newCategory = document.getElementById(selectedSubCategory)
        newCategory.appendChild(underline)
        newCategory.classList.add("filterItem__active")

        let prevCategory = document.getElementById(
          prevState.selectedSubCategory
        )
        prevCategory.removeChild(prevCategory.childNodes[1])
        prevCategory.classList.remove("filterItem__active")

        data.allMdx.edges.map(({ node }, index) => {
          if (selectedSubCategory === "View All") {
            this.setState(state => {
              const services = state.services.push(
                <ServiceBtn
                  link={node.fields.slug}
                  title={node.frontmatter.title}
                  img={node.frontmatter.img.childImageSharp.fluid}
                  id={node.frontmatter.title}
                  key={index}
                />
              )
            })
          } else if (
            node.frontmatter.subCategory === this.state.selectedSubCategory
          ) {
            this.setState(state => {
              const services = state.services.push(
                <div key={node.frontmatter.title}>
                  <ServiceBtn
                    link={node.fields.slug}
                    title={node.frontmatter.title}
                    img={node.frontmatter.img.childImageSharp.fluid}
                    id={node.frontmatter.title}
                  />
                </div>
              )
            })
          }
        })
      }
    }
  }

  render() {
    let { services } = this.state

    return (
      <div>
        <div>
          <div id="subCategoryFilter"></div>
        </div>
        <div className={servicesCategoryStyles.servicesGrid} id="servicesGrid">
          {services}
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query AviationServicesQuery {
    allMdx(
      filter: {
        frontmatter: { type: { eq: "Service" }, category: { eq: "Aviation" } }
      }
      sort: { fields: [frontmatter___title], order: ASC }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            type
            category
            subCategory
            title
            img {
              childImageSharp {
                fluid(maxWidth: 886, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
